import { IonItem, IonLabel, IonList, IonToggle } from '@ionic/react';
import StepLayout from './StepLayout';
import { modalToggleStore, toggleStore } from '../../../store/Store';

const ApplyPermit3 = () => {
    const subscribeToggle = toggleStore.useState((s) => s.subscribeToggle);

    const setSubscribe = (checked) => {
        toggleStore.update((s) => {
            s.subscribeToggle = checked;
        });
    };

    const openFourthPage = () => {
        modalToggleStore.update((s) => {
            s.permitPage = 4;
        });
    };

    return (
        <StepLayout
            title='Would you like to subscribe to this permit?'
            primaryLabel='Continue'
            onPrimary={openFourthPage}
        >
            <p>
                By subscribing, we will automatically renew your permit on your behalf. You can
                cancel your subscription at any time.
            </p>
            <p>
                If you turn off the subscription option below, your permit will not auto-renew after
                the first year. You may turn on the subscription at a later time from your "My
                Permits" page.
            </p>
            <p>
                You are responsible for informing the Parry Sound Fire Department if you intend to
                change your burn location and your permit may be subject to another inspection.
            </p>
            <IonList lines='full'>
                <IonItem>
                    <IonLabel className='ion-text-wrap'>
                        <strong>Subscribe</strong>
                        <span className='flow-choice__detail'>
                            Renew this permit automatically each year
                        </span>
                    </IonLabel>
                    <IonToggle
                        slot='end'
                        color='tertiary'
                        checked={subscribeToggle}
                        onIonChange={(e) => setSubscribe(e.detail.checked)}
                    />
                </IonItem>
            </IonList>
        </StepLayout>
    );
};

export default ApplyPermit3;
